import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { noop } from 'ui-components/default-props/noop';
import { Button } from 'ui-components/components/button';
import { AddressValidationStatus } from './validation-status';
import { isAddressInErrorOrWarningState, isAddressUnVerified } from './validate-address-helpers';
import { Revert } from './components/revert';
import { Revalidate } from './components/re-validate';

import { messages } from './messages';
import style from './address-validation.module.css';
import { emptyObject } from 'ui-components/default-props/empty';

export const AddressValidationSection = ({
  validateAddress = noop,
  revertToOriginalAddress = noop,
  shipToAddress = emptyObject,
  marketplaceShipTo = null,
  salesOrderId = '',
  shouldRenderAddressRevertLink = false,
}) => {
  const { verificationStatus } = shipToAddress;
  const onClick = useCallback(() => {
    validateAddress(shipToAddress);
  }, [shipToAddress, validateAddress]);
  const isErrorOrWarning = isAddressInErrorOrWarningState(verificationStatus);
  const isUnVerified = isAddressUnVerified(verificationStatus);

  if (isUnVerified) {
    return (
      <Button onClick={onClick} theme='link'>
        <FormattedMessage {...messages.validateAddress} />
      </Button>
    );
  }
  return (
    <div className={style['validate-links']}>
      <AddressValidationStatus
        countryCode={shipToAddress.countryCode}
        residentialIndicator={shipToAddress.residentialIndicator}
        validateAddress={validateAddress}
        validation={verificationStatus}
        validationMessage={shipToAddress.verificationMessage}
      />
      {isErrorOrWarning && <Revalidate onClick={onClick} />}
      {shouldRenderAddressRevertLink && (
        <Revert
          marketplaceShipTo={marketplaceShipTo}
          onClick={revertToOriginalAddress}
          salesOrderId={salesOrderId}
          shipToAddress={shipToAddress}
        />
      )}
    </div>
  );
};

AddressValidationSection.propTypes = {
  validateAddress: PropTypes.func,
  revertToOriginalAddress: PropTypes.func,
  shipToAddress: PropTypes.object,
  marketplaceShipTo: PropTypes.object,
  salesOrderId: PropTypes.string,
  shouldRenderAddressRevertLink: PropTypes.bool,
};
